<div *ngIf="!grid && !!page && page.show_last_visited_customers !== '1'" class="find-customers__grid-message">
    <tt-toast ttType="primary" ttTitle="customer_search" ttTranslateTitle>
        <span message>
            <span ttTranslateWord="findcustomers_search_description"></span>&nbsp;
            <button type="button" class="find-customers__load-all" (click)="readAllCustomers()"><span ttTranslateWord="show_all"></span></button>
        </span>
    </tt-toast>
</div>
<tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
